import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import Loading from "../../../Components/Loading";
import { ToDateJalali } from "../../../Utils/functions";
import { useSupport } from "../Hooks/support";

const Support = () => {
  const { handler, get, send, loading, toggle, form, data, render, navigate } =
    useSupport();

  console.log("da", data);

  if (loading.get) {
    return (
      <div>
        <Loading count={3} />
      </div>
    );
  }

  return (
    <>
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">پشتیبانی</p>
        </div>
      </header>
      <div className="container mt-3 support">
        <div className="row">
          <div className="col">
            <div className="profile">
              <div className="row">
                <div className="col-12">
                  {" "}
                  <label className="form-label" htmlFor="first-name">
                    عنوان
                  </label>
                  <input
                    className="form-control"
                    id="first-name"
                    type="text"
                    onChange={({ target: { value } }) => {
                      handler("title", value);
                    }}
                  />
                </div>
                <div className="col-12">
                  {" "}
                  <label className="form-label" htmlFor="first-name">
                    توضیحات
                  </label>
                  <textarea
                    className="form-control"
                    id="first-name"
                    type="text"
                    onChange={({ target: { value } }) => {
                      handler("description", value);
                    }}
                    rows={6}
                  ></textarea>
                </div>
                <div className="col-12">
                  {" "}
                  <label className="form-label" htmlFor="email2">
                    دپارتمان
                  </label>
                  <select
                    className="form-control mb-2"
                    id="email2"
                    type="text"
                    onChange={({ target: { value } }) => {
                      handler("departman_id", value);
                    }}
                  >
                    <option>انتخاب کنید</option>
                    <option value={"sale"}>فروش</option>
                    <option value={"technical"}>فنی</option>
                    <option value={"Financial"}>مالی</option>
                    <option value={"experts"}>فروشنده</option>
                  </select>
                </div>
                <div className="col-12">
                  <button className="btn btn-primary w-100" onClick={send}>
                    {loading.send ? <Spinner /> : "ارسال"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col">
            <h6 className="ticket-title">لیست تیکت ها</h6>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-12">
            {data?.data?.length == 0 ? (
              <div className="d-flex mt-5 justify-content-center align-items-center h-100">
                <p>تیکتی یافت نشد!</p>
              </div>
            ) : (
              data?.data?.map(ticket => {
                return (
                  <Link
                    to={`${ticket.id}`}
                    className={`ticket ${
                      form?.selected?.id == ticket.id ? "ticket-active" : ""
                    }`}
                    key={ticket.id}
                  >
                    <div className="ticket-icon">
                      <img
                        src={require("../../../assets/images/logo.png")}
                        style={{ width: "120px", objectFit: "contain" }}
                      />
                    </div>
                    <div className="ticket-content">
                      <h4 className="fs-15">پشتیبانی</h4>
                      <p className="fs-10">{ticket.title}</p>
                    </div>
                    <div className="ticket-time">
                      <span className="">
                        {ToDateJalali(ticket.created_at)}
                      </span>
                      <div>{render(ticket.status)}</div>
                    </div>
                  </Link>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
